import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faSpinner, faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';

import { sendChatMessage, AIProvider } from '../../apis/aiService';
import { getAllMediaContextFromData } from '../AIChatbot/mediaContext';
import { useContentData } from '../../hooks/useContentData';
import * as S from './style';

const RECOMMEND_PROMPTS = [
  { label: 'APEC 관련', prompt: 'APEC 2025 관련 콘텐츠를 추천해주세요. 어떤 영상, 이미지, 오디오가 있는지 간단히 설명해주세요.' },
  { label: '문화/역사', prompt: '경북 문화와 역사 관련 콘텐츠를 추천해주세요.' },
  { label: '오늘의 추천', prompt: '오늘 볼만한 콘텐츠를 3개 추천해주세요. 다양한 종류로 골라주세요.' },
  { label: '인기 콘텐츠', prompt: '가장 인기 있을 것 같은 콘텐츠를 추천해주세요.' },
];

function AIRecommend() {
  const { data: contentData } = useContentData();
  const [recommendation, setRecommendation] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [activePrompt, setActivePrompt] = useState('');

  const handleRecommend = async (prompt: string) => {
    if (isLoading) return;
    setIsLoading(true);
    setActivePrompt(prompt);
    setRecommendation('');

    try {
      const context = contentData ? getAllMediaContextFromData(contentData) : '';
      const result = await sendChatMessage(
        [{ role: 'user', content: prompt }],
        'ollama' as AIProvider,
        context
      );
      setRecommendation(result);
    } catch (err) {
      setRecommendation('추천을 불러오는 중 오류가 발생했습니다. AI 서비스 연결을 확인해주세요.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.RecommendSection>
      <S.SectionHeader>
        <S.SectionTitle>
          <FontAwesomeIcon icon={faMagicWandSparkles} style={{ color: '#33ff99' }} />
          {' AI 추천'}
        </S.SectionTitle>
        <S.SectionSubtitle>AI가 맞춤 콘텐츠를 추천해드립니다</S.SectionSubtitle>
      </S.SectionHeader>

      <S.PromptButtons>
        {RECOMMEND_PROMPTS.map((item, i) => (
          <S.PromptBtn
            key={i}
            onClick={() => handleRecommend(item.prompt)}
            disabled={isLoading}
            $active={activePrompt === item.prompt}
          >
            <FontAwesomeIcon icon={faBrain} /> {item.label}
          </S.PromptBtn>
        ))}
      </S.PromptButtons>

      {(isLoading || recommendation) && (
        <S.ResultBox>
          {isLoading ? (
            <S.LoadingText>
              <FontAwesomeIcon icon={faSpinner} spin /> AI가 콘텐츠를 분석하고 있습니다...
            </S.LoadingText>
          ) : (
            <S.RecommendText>{recommendation}</S.RecommendText>
          )}
        </S.ResultBox>
      )}
    </S.RecommendSection>
  );
}

export default AIRecommend;
